import { jsx as _jsx } from "react/jsx-runtime";
import { SafeAnchor } from 'react-bootstrap';
import classNames from 'classnames';
export const NavLink = props => (_jsx(SafeAnchor, Object.assign({ onClick: props.onClick, className: classNames(['nav-link', props.className, props.active ? 'active' : '']) }, { children: props.children })));
